<template>
  <div class="header_box">
    <div class="header_box_content layout">
      <div class="header_box_content_left">
        <img class="header_box_content_left_logo" src="@/assets/img/header/xbrc-logo-sp.png@2x.png" alt="">
        <div class="header_box_content_left_position">
          <img src="@/assets/img/header/position_header.png" alt="">
          <div>{{ station }} <span @click="selectClick">【切换】</span></div>
        </div>
      </div>
      <div class="header_box_content_right">
        <div :class="routerId == item.path ? 'header_box_content_right_item nav_active' : 'header_box_content_right_item'"
          v-for="(item, index) in navList" :key="index" @click="activeChange(item, index)">
          <span>{{ item.label }}</span>
          <div class="header_box_content_right_item_children"
            v-if="item.children && item.children.length > 0 && routerId == item.path && show">
            <span :class="routerId == i.path ? 'children_active' : ''" v-for="(i, j) in item.children" :key="j"
              @click="childrenClick(i, j)">{{ i.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model:visible="modal2Visible" :footer="null" width="700px" :bodyStyle="bodyStyle" :closable="false">
      <div class="model_header">
        <div>切换分站
          <img @click="modal2Visible = false" src="@/assets/img/header/close_icon.png" alt="">
        </div>
        <span>切换到一下分站</span>
      </div>
      <div class="model_content">

        <ul>
          <li v-for="(item, index) in stationList" :key="index" @click="select(item)">
            <span :class="station == item.tenantName ? 'active' : ''">{{ item.tenantName }}</span>
          </li>
        </ul>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { tenantInfolist } from "@/api/home";

export default {
  data() {
    return {
      active: true,
      station: "总站",
      http: '',
      navList: [
        { label: '首页', path: '/' },
        { label: '职位', path: '/personjob' },
        { label: '招聘会', path: '/jobfair/recruitment' },
        { label: '交付RPO', path: '/headfairmain/headfairRpo' },        
        { label: '招考培训', path: '/employment' },
        {
          label: '简历优化', path: '/resumeTop', children: [
            { label: '简历置顶', path: '/resumeTop' },
            { label: '简历模板', path: '/resumeOptimization/templateIndex' },
            { label: '简历优化', path: '/resumeOptimization/resumeTemplate' },
          ]
        },		
		// { label: '佰才速聘', path: '/headfair' },
        // { label: '管理咨询', url: 'https://www.xbrc.com.cn/oss/xbrcw/gg-html/2025-12-30/6c317078-35cf-46df-83bc-346c8b8b6e87/index.html' },
		{ label: '资讯中心', path: '/jobrefer' },
		{
		  label: '中小企业', path: '/nsmep', children: [
		    { label: '管理咨询', path: '/ConsultingPage' },
		    { label: '中小企业', path: '/nsmep' },
		  ]
		},		
        // 添加菜单应用，后期又改为零工兼职
		// { label: '零工兼职', path: '/agilittyUseSking' },
        { label: '零工兼职', url: 'https://www.xbrc.com.cn/oss/xbrcw/gg-html/2026-02-04/fc66365c-d47b-47e8-ba1a-d9cf22fa8bf4/index.html' },
		{ label: '甘肃人力', url: 'http://www.gsrl.com/' },
      ],
      activeIndex: 0,
      childrenIndex: 0,
      show: false,
      modal2Visible: false,
      stationList: [],
      bodyStyle: {
        padding: '24px 32px',
        margin: '10% auto',
      },
      token: undefined,
    };
  },
  computed: {
    routerId: function () {
      return this.$route.path;
    },
  },
  watch: {},
  created() {

  },
  mounted() {

    this.gettenantInfolist()

    this.http = location.href
    console.log(location.href,'location.hostname')
    this.navList.forEach(item => {
      if (item.children && item.children.length > 0) {
        item.children.forEach((elem, index) => {
          if (elem.path == this.routerId) {
            item.path = elem.path
          }
        })
      }
    })
    this.token = Cookies.get("JobseekerAuthorization");
    this.gettenantInfolist()
  },
  methods: {
    gettenantInfolist() {
      tenantInfolist().then(res => {
        console.log(this.http,'http')
        console.log(res,'0000')
        let obj = {
          domain: 'https://www.xbrc.com.cn/',
          tenantName: '总站分站'
        }
        let data = res.data
        data.unshift(obj)
        console.log(data,'总的数据')
        data.forEach(item => {
          item.tenantName = item.tenantName.slice(0, -2);
          if (this.http.includes(item.domain)) {
            this.station = item.tenantName
            console.log(this.station,'sss')
          }
        })
        this.stationList = data
        console.log(this.stationList, 'this.stationList')

      })
    },
    activeChange(item, index) {
      this.activeIndex = index
      if(item.path == '/agilittyUseSking') return ;
      if (item.children && item.children.length > 0) {
        this.show = true
      } else {
        this.show = false
      }
      if (item.path) {
        if (item.path == '/resumeTop' && !this.token) {
          this.$confirm("请先登录求职者账号！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$router.push({ path: "/login" });
          })
        } else {
          this.$router.push(item.path)
        }
      } else {
        window.open(item.url)
      }
    },
    childrenClick(i, j) {
      this.childrenIndex = j
      console.log(this.show, '简历优化')
      this.$router.push(i.path)
      this.navList.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((elem, index) => {
            if (j == index) {
              item.path = elem.path
            }
          })
        }
      })
      setTimeout(() => {
        this.show = false

      }, 1000)
    },
    selectClick() {
      this.modal2Visible = true
    },
    select(item) {
      console.log(item, '点击分站')
      this.$nextTick(() => {
        this.station = item.tenantName
        this.modal2Visible = false
        window.open(item.domain, '_self')
      })
      this.$forceUpdate()
    },
  },
};
</script>

<style scoped>
.header_box {
  height: 60px;
  width: 100%;
  background: rgba(32, 35, 41, 1);
  padding: 18px 0;
  box-sizing: border-box;
}

.header_box_content {
  display: flex;
  align-items: center;
}

.header_box_content_left {
  display: flex;
}

.header_box_content_left_logo {
  width: 154px;
  height: 24px;
  margin-right: 24px;
}

.header_box_content_left_position {
  display: flex;
  margin-top: 4px;
}

.header_box_content_left_position>img {
  width: 12px;
  height: 16px;
  margin-right: 3px;
}

.header_box_content_left_position>div {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  color: rgba(255, 141, 26, 1);
  text-align: left;
  vertical-align: top;
}

.header_box_content_left_position>div>span {
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}

.header_box_content_right {
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-left: 24px;
}

.header_box_content_right_item {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  vertical-align: top;
  position: relative;
  cursor: pointer;
}

.nav_active {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 141, 26, 1);
  text-align: left;
  vertical-align: top;
}

.header_box_content_right_item_children {
  width: 98px;
  background: rgba(32, 35, 41, 1);
  position: absolute;
  top: 39px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
}

.header_box_content_right_item_children>span {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 36px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  display: block;
}

.children_active {
  color: rgba(255, 141, 26, 1) !important;
}

.model_content>ul {
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  margin-right: -14px;
}

.model_content>ul>li {
  width: 94px;
  height: 40px;
  opacity: 1;
  background: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  border: 1px solid rgba(204, 204, 204, 1);
  margin: 0 14px 23px 0;
  cursor: pointer;
}

.model_header {
  border-bottom: 1px solid rgba(232, 232, 232, 1);
  margin-bottom: 18px;
}

.model_header>div {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 34.75px;
  color: rgba(255, 141, 26, 1);
  text-align: left;
  vertical-align: top;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.model_header>div>img {
  width: 13px;
  height: 13px;
  cursor: pointer;
}

.model_header>span {
  display: block;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 26.06px;
  color: rgba(102, 102, 102, 1);
  text-align: left;
  vertical-align: top;
  margin: 14px 0 17px 0;
}

.header_box /deep/ .ant-modal-close {
  top: 30px;
}

.active {
  color: rgba(255, 141, 26, 1);
}
</style>
